import { render, staticRenderFns } from "./jobseekersidebar.vue?vue&type=template&id=33e3b1d3&scoped=true"
import script from "./jobseekersidebar.vue?vue&type=script&lang=js"
export * from "./jobseekersidebar.vue?vue&type=script&lang=js"
import style0 from "./jobseekersidebar.vue?vue&type=style&index=0&id=33e3b1d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e3b1d3",
  null
  
)

export default component.exports